import ElementRouter from '../utils/element-router';
import EventView from './event';
import './tasks';

ElementRouter({
	routes: [{ selector: '#terminhinweis', view: EventView }],
});
